import { configureStore as configureStoreReduxToolkit } from '@reduxjs/toolkit';
import { rootReducer } from '../../redux/reducers';
import { useDispatch } from 'react-redux';
import reduceReducers from 'reduce-reducers';
import { productActivationsApi } from '../../redux/api/api.productActivations';
import { assetsApi } from '../../redux/api/api.assets';
import { unitsApi } from '../../redux/api/api.units';
import { assetsInUnitsApi } from '../../redux/api/api.unitAssets';

const reducer = rootReducer();

export const configureStore = () =>
    configureStoreReduxToolkit({
        reducer: reduceReducers(reducer),
        middleware: getDefaultMiddleware =>
            getDefaultMiddleware({ immutableCheck: false, serializableCheck: false })
                .concat(productActivationsApi.middleware)
                .concat(assetsApi.middleware)
                .concat(unitsApi.middleware)
                .concat(assetsInUnitsApi.middleware),
    });

export const store = configureStore();

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
